<template>
    <div class="coldContainer" :class="{'coldContainerDark' : isDark}">
        <TitleBar title="泊松分布" :txt="txt" :type="type"></TitleBar>
        <div class="coldBox">
            <div class="coldCard left" @click="goModelList">
                <p>{{poissonLeft.home_team}}</p>
                <p>{{poissonLeft.guest_team}}</p>
                <div class="btm">
                    <span class="league" :style="{color: poissonLeft.sclass_color}">{{poissonLeft.sclass_name}}</span>
                    <span class="time">{{matchTimeLeft}}</span>
                </div>
                <div class="result">
                    <p v-if="poissonData.is_pay === 0" class="val">{{poissonLeft.rec_vs_hit === 1 ? (poissonLeft.rec_vs_hit_odds + '倍') : ''}}</p>
                    <p v-else>
                        <ChartsPie
                            id="poissonPieLeft"
                            :colors = "['#FF5048',isDark ? '#2f2f2f':'#eeeeee']"
                            :data="[recBfbLeft, 100 - recBfbLeft]"
                            type="poisson"
                            :text="poissonLeft.rec_bfb"
                        />
                    </p>
                    <p v-if="poissonData.is_pay === 0">{{poissonLeft.rec_vs_hit === 1 ? '比分命中' : ''}}</p>
                    <p v-else>{{poissonLeft.rec_score}}球概率</p>
                </div>
            </div>
            <div class="coldCard" @click="goModelList">
                <p>{{poissonRight.home_team}}</p>
                <p>{{poissonRight.guest_team}}</p>
                <div class="btm">
                    <span class="league" :style="{color: poissonRight.sclass_color}">{{poissonRight.sclass_name}}</span>
                    <span class="time">{{matchTimeRight}}</span>
                </div>
                <div class="result">
                    <p v-if="poissonData.is_pay === 0" class="val">{{poissonRight.rec_vs_hit === 1 ? (poissonRight.rec_vs_hit_odds + '倍') : ''}}</p>
                    <p v-else>
                        <ChartsPie
                            id="poissonPieRight"
                            :colors = "['#FF5048',isDark ? '#2f2f2f':'#eeeeee']"
                            :data="[recBfbRight, 100 - recBfbRight]"
                            type="poisson"
                            :text="poissonRight.rec_bfb"
                        />
                    </p>
                    <p v-if="poissonData.is_pay === 0">{{poissonRight.rec_vs_hit === 1 ? '比分命中' : ''}}</p>
                    <p v-else>{{poissonRight.rec_score}}球概率</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TitleBar from './common/titleBar.vue'
import ChartsPie from '../../components/datamodel/common/chartsPie.vue'
export default {
    name: 'poissonCorpus',
    props: ['poissonData'],
    components: {
        TitleBar,
        ChartsPie
    },
    watch: {
        data: {
            handler () {
                this.renderPoissonList();
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    data () {
        return {
            type: "21",
            txt: '',
            poissonLeft: {},
            poissonRight: {},
            matchTimeLeft: '',
            matchTimeRight: '',
            recBfbLeft: 0,
            recBfbRight: 0
        }
    },
    methods: {
        renderPoissonList () {
            if (this.poissonData) {
                this.poissonLeft = this.poissonData.list[0];
                this.poissonRight = this.poissonData.list[1];
                if (this.poissonData.list[0]) {
                    const leftBfb = this.poissonData.list[0].rec_bfb;
                    this.recBfbLeft = leftBfb.substring(0, leftBfb.length - 1);
                }
                if (this.poissonData.list[1]) {
                    const rigthBfb = this.poissonData.list[1].rec_bfb;
                    this.recBfbRight = rigthBfb.substring(0, rigthBfb.length - 1);
                }
                this.matchTimeLeft = this.poissonData.list[0].match_time.substring(5, 16).replace('-', '月');
                this.matchTimeRight = this.poissonData.list[1].match_time.substring(5, 16).replace('-', '月');
                if (this.poissonData.type_num * 1 > 0) {
                    this.txt = '（今日命中' + this.poissonData.type_num + '场）';
                } else {
                    this.txt = '';
                }
            }
        },
        goModelList () {
            this.$emit('goDetail', this.type);
        }
    }
}
</script>
